"use client"

import { fetchErrorAtom } from "@/app/state";
import { useAtom } from "jotai";

export default function FetchErrorBanner() {
  const [fetchError] = useAtom(fetchErrorAtom)

  if(!fetchError) {
    return null
  }

  return (
    <div className="w-full bg-red-600 text-white justify-center flex font-bold p-4">
      There was an issue fetching data. Please try again later.
    </div>
  )
}
